/* ==========================================================================
   eg-wormwood-complex — landing page behaviour

   The offer is the only moving part. One variant, three quantity tiers, and a
   refill toggle that decides both the prices shown and what the cart receives.
   ========================================================================== */
(function () {
  'use strict';

  var SHIP_OFFSET_DAYS = 20;

  var MONTHS = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  /* ---------------------------------------------------------------- utils */

  function on(el, evt, fn, opts) {
    if (el) el.addEventListener(evt, fn, opts);
  }

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /* ------------------------------------------------------------------ boot */

  function init(root) {
    if (!root || root.dataset.egwwInit === 'true') return;
    root.dataset.egwwInit = 'true';

    var subscribeBox = root.querySelector('[data-egww-subscribe]');
    var state = {
      tier: root.querySelector('[data-egww-tier].is-selected') || root.querySelector('[data-egww-tier]'),
      // the design ships with refills opted in
      subscribe: !!(subscribeBox && subscribeBox.checked)
    };

    countdown(root);
    gallery(root);
    accordions(root);
    slider(root);
    shipDate(root);
    offer(root, state);
  }

  /* ------------------------------------------------------------ countdown */

  function countdown(root) {
    var el = root.querySelector('[data-egww-countdown]');
    if (!el) return;

    var TOTAL = 60 * 60 * 1000; // one hour
    var key = 'egwwSaleEnd';
    var end = parseInt(sessionStorage.getItem(key) || '0', 10);

    if (!end || end < Date.now()) {
      end = Date.now() + TOTAL;
      try {
        sessionStorage.setItem(key, String(end));
      } catch (e) {
        /* private mode — keep the in-memory value */
      }
    }

    function tick() {
      var left = Math.max(0, end - Date.now());
      var s = Math.floor(left / 1000);
      el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      if (left <= 0) {
        end = Date.now() + TOTAL;
        try {
          sessionStorage.setItem(key, String(end));
        } catch (e) {
          /* noop */
        }
      }
    }

    tick();
    setInterval(tick, 1000);
  }

  /* -------------------------------------------------------------- gallery */

  function gallery(root) {
    var track = root.querySelector('[data-egww-gallery-track]');
    var slides = track ? track.querySelectorAll('[data-egww-gallery-slide]') : [];
    var thumbs = root.querySelectorAll('[data-egww-thumb]');
    var strip = root.querySelector('[data-egww-thumbs]');
    if (!track || !slides.length || !thumbs.length) return;

    each(thumbs, function (thumb, i) {
      on(thumb, 'click', function () {
        if (!slides[i]) return;
        track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      });
    });

    function sync() {
      var width = slides[0].getBoundingClientRect().width;
      var index = width > 0 ? Math.round(track.scrollLeft / width) : 0;
      index = Math.max(0, Math.min(index, thumbs.length - 1));

      each(thumbs, function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
      });

      // keep the active thumb inside the (scrollable) strip
      if (strip && strip.scrollWidth > strip.clientWidth) {
        var t = thumbs[index];
        var left = t.offsetLeft - strip.offsetLeft;
        if (left < strip.scrollLeft || left + t.offsetWidth > strip.scrollLeft + strip.clientWidth) {
          strip.scrollTo({ left: left - (strip.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
        }
      }
    }

    on(track, 'scroll', sync);
    window.addEventListener('resize', sync);
    sync();
  }

  /* ----------------------------------------------------------- accordions */

  function accordions(root) {
    each(root.querySelectorAll('[data-egww-acc]'), function (item) {
      var toggle = item.querySelector('[data-egww-acc-toggle]');
      if (!toggle) return;

      on(toggle, 'click', function () {
        var willOpen = !item.classList.contains('is-open');
        var group = item.closest('[data-egww-acc-group]');

        // one open at a time within a group, as the design shows
        if (group && willOpen) {
          each(group.querySelectorAll('[data-egww-acc]'), function (sibling) {
            if (sibling === item) return;
            sibling.classList.remove('is-open');
            var t = sibling.querySelector('[data-egww-acc-toggle]');
            if (t) t.setAttribute('aria-expanded', 'false');
          });
        }

        item.classList.toggle('is-open', willOpen);
        toggle.setAttribute('aria-expanded', String(willOpen));
      });
    });
  }

  /* ------------------------------------------------------------ ship date */

  function shipDate(root) {
    var el = root.querySelector('[data-egww-ship-date]');
    if (!el) return;
    var d = new Date();
    d.setDate(d.getDate() + SHIP_OFFSET_DAYS);
    el.textContent = MONTHS[d.getMonth()] + ' ' + d.getDate() + ordinal(d.getDate());
  }

  function ordinal(n) {
    if (n > 3 && n < 21) return 'th';
    return ['th', 'st', 'nd', 'rd'][n % 10] || 'th';
  }

  /* --------------------------------------------------------------- slider */

  /*
   * A looping quote carousel. The slides are stacked in one grid cell and
   * cross-faded, so wrapping past either end is just an index modulo — there is
   * no track to rewind and nothing jumps when it comes back round.
   */
  function slider(root) {
    each(root.querySelectorAll('[data-egww-slider]'), function (el) {
      var slides = el.querySelectorAll('[data-egww-slide]');
      var dotsHost = el.querySelector('[data-egww-slider-dots]');
      var prev = el.querySelector('[data-egww-slider-prev]');
      var next = el.querySelector('[data-egww-slider-next]');
      if (slides.length < 2) return;

      var current = 0;

      if (dotsHost) {
        // each slider styles and labels its own dots
        var dotClass = dotsHost.getAttribute('data-egww-dot-class') || 'egww__research-dot';
        var dotLabel = dotsHost.getAttribute('data-egww-dot-label') || 'Show quote';
        for (var i = 0; i < slides.length; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = dotClass;
          dot.dataset.index = String(i);
          dot.setAttribute('aria-label', dotLabel + ' ' + (i + 1));
          dotsHost.appendChild(dot);
        }
        on(dotsHost, 'click', function (event) {
          var dot = event.target.closest('[data-index]');
          if (dot) show(Number(dot.dataset.index));
        });
      }

      function show(index) {
        current = (index + slides.length) % slides.length;
        each(slides, function (slide, i) {
          var active = i === current;
          slide.classList.toggle('is-active', active);
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
        if (dotsHost) {
          each(dotsHost.children, function (dot, i) {
            dot.classList.toggle('is-active', i === current);
          });
        }
      }

      on(prev, 'click', function () { show(current - 1); });
      on(next, 'click', function () { show(current + 1); });

      // dragging the quote sideways moves the carousel too
      var startX = null;
      on(el, 'touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      on(el, 'touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
        startX = null;
      });

      show(0);
    });
  }

  /* ---------------------------------------------------------------- offer */

  function offer(root, state) {
    var tiers = root.querySelectorAll('[data-egww-tier]');
    var subscribeBox = root.querySelector('[data-egww-subscribe]');
    var frequency = root.querySelector('[data-egww-frequency]');
    var atcPrice = root.querySelector('[data-egww-atc-price]');
    var atcCompare = root.querySelector('[data-egww-atc-compare]');

    /*
     * The refill toggle swaps every price at once. The struck price is the
     * full pack at compare-at either way, so it does not move.
     */
    function render() {
      var tier = state.tier;
      if (!tier) return;

      var sub = state.subscribe;

      each(tiers, function (t) {
        var selected = t === tier;
        t.classList.toggle('is-selected', selected);
        t.setAttribute('aria-checked', String(selected));

        var price = t.querySelector('[data-egww-tier-price]');
        var compare = t.querySelector('[data-egww-tier-compare]');
        var save = t.querySelector('[data-egww-tier-save]');
        if (price) price.textContent = sub ? t.dataset.priceSub : t.dataset.priceOnce;
        if (save) save.textContent = sub ? t.dataset.saveSub : t.dataset.saveOnce;

        var unit = t.querySelector('[data-egww-tier-unit]');
        if (unit) unit.textContent = sub ? t.dataset.perbagSub : t.dataset.perbagOnce;

        // with no compare-at the struck price would repeat the live one
        var cents = Number(sub ? t.dataset.saveSubCents : t.dataset.saveOnceCents);
        if (compare) {
          compare.textContent = t.dataset.compare;
          compare.hidden = !(cents > 0);
        }
      });

      if (atcPrice) atcPrice.textContent = sub ? tier.dataset.priceSub : tier.dataset.priceOnce;
      if (atcCompare) {
        var saved = Number(sub ? tier.dataset.saveSubCents : tier.dataset.saveOnceCents) > 0;
        atcCompare.textContent = saved ? tier.dataset.compare || '' : '';
      }

      // each pack refills on its own cadence (4 / 8 / 12 weeks)
      if (frequency && tier.dataset.frequency) frequency.textContent = tier.dataset.frequency;
    }

    each(tiers, function (tier) {
      on(tier, 'click', function () {
        state.tier = tier;
        render();
      });
    });

    on(subscribeBox, 'change', function () {
      state.subscribe = subscribeBox.checked;
      render();
    });

    render();
    addToCart(root, state);
  }

  /* ---------------------------------------------------------- add to cart */

  function addToCart(root, state) {
    var buttons = root.querySelectorAll('[data-egww-atc]');
    var errors = root.querySelectorAll('[data-egww-cart-error]');

    var addUrl = root.dataset.cartAddUrl || '/cart/add.js';
    var clearUrl = root.dataset.cartClearUrl || '/cart/clear.js';

    function showError(message) {
      each(errors, function (el) {
        el.textContent = message;
        el.hidden = !message;
      });
    }

    function postJSON(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body || {})
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Cart request failed');
          return data;
        });
      });
    }

    /*
     * The pack is split across two lines when refills are on: the paid units
     * carry the selling plan and are what renews, the free units ride along
     * without one so the subscription does not renew them. The store's
     * Buy-X-Get-Y automatic discounts zero the free units at checkout.
     *
     * With refills off there is nothing to renew, so the pack is one line and
     * the discount resolves it on its own.
     */
    function itemsFor(tier, subscribe) {
      var id = Number(tier.dataset.variantId);
      var paid = Number(tier.dataset.paid) || 1;
      var free = Number(tier.dataset.free) || 0;

      if (!subscribe) return [{ id: id, quantity: paid + free }];

      var items = [{ id: id, quantity: paid }];
      if (tier.dataset.sellingPlan) items[0].selling_plan = Number(tier.dataset.sellingPlan);
      if (free > 0) items.push({ id: id, quantity: free });
      return items;
    }

    /* The cart only ever holds this one offer, so it is cleared first. */
    function buy(items, busy) {
      showError('');
      each(busy, function (b) { b.setAttribute('aria-busy', 'true'); });

      return postJSON(clearUrl)
        .then(function () {
          return postJSON(addUrl, { items: items });
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          // stay on the page so the shopper can retry rather than bouncing them
          each(busy, function (b) { b.removeAttribute('aria-busy'); });
          showError(err.message || 'Something went wrong. Please try again.');
          console.error('[eg-wormwood-complex] add to cart:', err);
        });
    }

    each(buttons, function (button) {
      on(button, 'click', function () {
        if (state.tier) buy(itemsFor(state.tier, state.subscribe), buttons);
      });
    });
  }

  /* ------------------------------------------------------------------ run */

  function boot() {
    each(document.querySelectorAll('[data-egww]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
